// Toggle search-bar when user click on button in header
// Both desktop and mobile version of the search-bar will close/open, but only one will be displayed acording to media queries in css
$(".js-toggle-header-search").click(function (e) {
    $(".header__search-bar").toggleClass("header__search-bar--open");

    // Set focus on search input when toggle search is clicked.
    var $searchBarMobile = $('.header__search-bar--mobile');

    // ?: Is search bar mobile visible?
    if ($searchBarMobile.is(':visible')) {
        // -> Yes, set focus on mobile input
        $('.header__search-bar--mobile input').focus();
    }
    else {
        // -> No, set focus on desktop input
        $('.header__search-bar--desktop input').focus();
    }
});

// Close search-bar when user click outside of the search-bar container (desktop version of the search-bar does not have a close button)
$(document).mouseup(function (e) {
    var searchBar = $(".header__search-bar");

    // if the target of the click isn't the container nor a descendant of the container
    if (!searchBar.is(e.target) && searchBar.has(e.target).length === 0) {
        // Close searchbar
        searchBar.removeClass("header__search-bar--open")
    }
});

// Add toggle filter click event for search result page
$(".search-page .toggle-filter").click(function () {
    $(".toggle-filter-container").toggleClass("open");
    $(".search-filter").toggle();
});